import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class KeynottagRepStore {
    loading = false;
    total = 0;
    customerFeedbackData = [];
    tripData = [];

    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            customerFeedbackData: observable,
            tripData: observable,

            loadData: action,

            exportExcel: action,
            exportpdf: action,
        });
        this.rootStore = rootStore;
    }

    async loadData({
        companyId,
        driverId,
        fromDate,
        toDate,
        offset,
        limit,
        pageNo,
    }) {
        this.loading = true;
        var postData = {
            companyId: companyId,
            driverId: driverId,
            fromDate: fromDate,
            toDate: toDate,
            offset: offset,
            limit: limit,
            page: pageNo,
        };

        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post(
                "index.php?c=traxi_booking&a=CustomerFeedbackReport",
                "postData=" + base64Input
            );

        this.customerFeedbackData = response?.data?.data?.CustomerFeedbackReport;

        this.total = parseInt(response?.data?.data?.TotalCount);

        this.loading = false;
    }

    async exportExcel(getData) {
        window.location.href =
            baseURL +
            "index.php?c=traxi_booking&a=exportCustomerFeedbackExcel&cid=" +
            getData.companyId +
            "&driverId=" +
            getData.driverId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList;
    }

    async exportpdf(getData) {
        window.location.href =
            baseURL +
            "index.php?c=traxi_booking&a=exportCustomerFeedbackPdf&cid=" +
            getData.companyId +
            "&vid=" +
            "&driverId=" +
            getData.driverId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&userId=" +
            getData.userId +
            "&colList=" +
            getData.colList;
    }
}

export default KeynottagRepStore;
